export const PLATFORM_FEE_PAGE_UUID = 'a77f5cf7-7d30-46ce-a4bc-8dbed1697a31'
